import React from 'react';
import { useTranslatedContent } from '../../../i18n/hooks/useTranslatedContent';
import ExpertiseFeature from './ExpertiseFeature';
import { expertiseIcons } from '../../../data/expertise-icons';

const ExpertiseFeatureGrid = () => {
  const { t } = useTranslatedContent('expertise');
  const features = t('features', { returnObjects: true });

  if (!Array.isArray(features)) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      {features.map((feature, index) => (
        <ExpertiseFeature
          key={index}
          icon={expertiseIcons[index]}
          title={feature.title}
          description={feature.description}
        />
      ))}
    </div>
  );
};

export default ExpertiseFeatureGrid;